import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'payment.thankyou.purchase.free': {
    id: 'payment.thankyou.purchase.free',
    defaultMessage: 'order',
    description: 'Free purchase message',
  },
  'payment.thankyou.purchase.paid': {
    id: 'payment.thankyou.purchase.paid',
    defaultMessage: 'payment',
    description: 'Paid purchase message',
  },
  'payment.thankyou.view.receipt': {
    id: 'payment.thankyou.view.receipt',
    defaultMessage: 'View receipt',
    description: 'CTA to view the receipt after successful payment',
  },
  'payment.thankyou.main.body.credit': {
    id: 'payment.thankyou.main.body.credit',
    defaultMessage: 'You have successfully purchased credit for this course.',
    description: 'Purchase success message body for credit',
  },
  'payment.thankyou.main.body.program': {
    id: 'payment.thankyou.main.body.program',
    defaultMessage:
      "Your {purchase} is completed and we've confirmed your entitlement(s).",
    description: 'Purchase success message body for programs',
  },
  'payment.thankyou.main.body.course': {
    id: 'payment.thankyou.main.body.course',
    defaultMessage:
      "Your {purchase} is completed and we've confirmed your enrollment.",
    description: 'Purchase success message body for courses',
  },
  'payment.thankyou.main.body.summary': {
    id: 'payment.thankyou.main.body.summary',
    defaultMessage: 'Below is a summary of your order.',
    description: 'Summary of the order after successful payment',
  },
  'payment.thankyou.pending.subheading': {
    id: 'payment.thankyou.pending.subheading',
    defaultMessage: 'Your payment is processing.',
    description: 'Status message while the payment has not settled yet',
  },
  'payment.thankyou.pending.heading': {
    id: 'payment.thankyou.pending.heading',
    defaultMessage: "Thanks! We're finishing up your order.",
    description: 'Heading shown while the payment is still processing',
  },
  'payment.thankyou.pending.body': {
    id: 'payment.thankyou.pending.body',
    defaultMessage:
      'Your bank is still confirming this payment, which can take a few minutes. You can safely close this page.',
    description: 'Explanation of the processing payment state',
  },
  'payment.thankyou.pending.body.confirmation': {
    id: 'payment.thankyou.pending.body.confirmation',
    defaultMessage:
      "We'll email your order confirmation once the payment completes, and your purchase will appear on your dashboard.",
    description: 'What the learner should expect after the payment settles',
  },
  'payment.thankyou.pending.dashboard': {
    id: 'payment.thankyou.pending.dashboard',
    defaultMessage: 'Go to dashboard',
    description:
      'CTA to return to the learner dashboard while payment is processing',
  },
});
